import { Component, ChangeDetectionStrategy } from "@angular/core";
import { LocalizableComponent } from "../localizable/localizable.component";

@Component({
    selector: 'storage-account-down-toast',
    templateUrl: './storage-account-down-toast.component.html',
    styleUrls: [
        './storage-account-down-toast.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StorageAccountDownToast extends LocalizableComponent {
  isVisible: boolean = true;

  constructor () {
    super();
  }
}
